import { p as proxyCustomElement, H, d as createEvent, h } from './p-23afa4c1.js';
import { d as defineCustomElement$2 } from './p-0f8558ea.js';
import { b as bem } from './p-a05fe53c.js';
import { g as getDefaultSlotTextContent, h as hasNamedSlot } from './p-bde29a8a.js';
import { t as transformTagName, r as resolveAppearance } from './p-d1ae9dd0.js';

const cosmosRadioCss = "@charset \"UTF-8\";:host{display:block;min-width:0;width:100%}.cosmos-radio{-ms-flex-align:baseline;align-items:baseline;display:-ms-flexbox;display:flex}.cosmos-radio__input-and-prefix{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0}.cosmos-radio__aligner{--cosmos-text-font-family:var(--cosmos-radio-font-family);--cosmos-text-font-size:var(--cosmos-radio-font-size);--cosmos-text-font-style:var(--cosmos-radio-font-style);--cosmos-text-font-weight:var(--cosmos-radio-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-line-height);--cosmos-text-text-transform:var(--cosmos-radio-text-transform);width:0}.cosmos-radio__aligner::before{content:\" \"}.cosmos-radio__input-container{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-negative:0;flex-shrink:0;height:var(--cosmos-radio-size, 16px);-ms-flex-pack:center;justify-content:center;position:relative;width:var(--cosmos-radio-size, 16px)}.cosmos-radio__input-container--end-margin{-webkit-margin-end:var(--cosmos-radio-gap, calc(0.5 * var(--cosmos-radio-size, 16px)));margin-inline-end:var(--cosmos-radio-gap, calc(0.5 * var(--cosmos-radio-size, 16px)))}.cosmos-radio--has-prefix .cosmos-radio__input-container--end-margin{-webkit-margin-end:calc(2 * var(--cosmos-radio-gap, calc((0.5 * var(--cosmos-radio-size, 16px)) * 0.5)));margin-inline-end:calc(2 * var(--cosmos-radio-gap, calc((0.5 * var(--cosmos-radio-size, 16px)) * 0.5)))}.cosmos-radio__prefix{display:grid}.cosmos-radio__prefix ::slotted([slot=prefix]){--cosmos-icon-size:18px;--cosmos-flag-width:18px;--cosmos-avatar-size:18px}.cosmos-radio--has-prefix .cosmos-radio__prefix--end-margin{-webkit-padding-end:var(--cosmos-radio-gap, calc(0.375 * var(--cosmos-radio-size, 16px)));padding-inline-end:var(--cosmos-radio-gap, calc(0.375 * var(--cosmos-radio-size, 16px)))}.cosmos-radio--has-prefix .cosmos-radio__prefix{position:relative}.cosmos-radio--has-prefix .cosmos-radio__prefix::before{content:\"\";display:block;height:100%;left:0;min-height:calc(var(--cosmos-radio-size, 16px) + calc(0.25 * var(--cosmos-radio-size, 16px)) * 2);position:absolute;right:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.cosmos-radio__input{-ms-flex-align:center;align-items:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none;border-radius:9999px;border-style:solid;border-width:var(--cosmos-radio-border-width, 1px);-webkit-box-shadow:none;box-shadow:none;-webkit-box-sizing:border-box;box-sizing:border-box;display:-ms-flexbox;display:flex;height:var(--cosmos-radio-size, 16px);-ms-flex-pack:center;justify-content:center;margin:0;outline:none;padding:0;width:var(--cosmos-radio-size, 16px)}.cosmos-radio__input:focus,.cosmos-radio__input:focus:not(:focus-visible){outline:none}.cosmos-radio__input:focus:not(:focus-visible)::before{content:none}.cosmos-radio__input:focus::before{border-radius:calc(9999px * 1.5);bottom:calc((4px + 0px) * -1);-webkit-box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;box-shadow:inset 0 0 0 2px #1B6AEE, 0 0 0 2px #FFFFFF;left:calc((4px + 0px) * -1);position:absolute;right:calc((4px + 0px) * -1);top:calc((4px + 0px) * -1);content:\"\"}.cosmos-radio__input::after{-webkit-box-sizing:content-box;box-sizing:content-box;content:\"\";display:block;height:calc(var(--cosmos-radio-size, 16px) + calc(0.25 * var(--cosmos-radio-size, 16px)) * 2);position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:calc(var(--cosmos-radio-size, 16px) + calc(0.25 * var(--cosmos-radio-size, 16px)) * 2);z-index:1}.cosmos-radio__input~.cosmos-radio__dot{border-radius:9999px;display:block;height:6px;left:0;margin:auto;opacity:0;position:absolute;right:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:6px}.cosmos-radio__input:checked~.cosmos-radio__dot{opacity:1}.cosmos-radio__content{min-width:0;position:relative}.cosmos-radio__content--row{width:100%}.cosmos-radio__content--row label{width:100%}.cosmos-radio__label{display:block;min-width:0;position:relative}.cosmos-radio__label::before{bottom:calc(calc(0.25 * var(--cosmos-radio-size, 16px)) * -1);content:\"\";left:0;position:absolute;right:0;top:calc(calc(0.25 * var(--cosmos-radio-size, 16px)) * -1)}.cosmos-radio__label-text{--cosmos-text-color:var(--cosmos-radio-color);--cosmos-text-font-family:var(--cosmos-radio-font-family);--cosmos-text-font-size:var(--cosmos-radio-font-size);--cosmos-text-font-style:var(--cosmos-radio-font-style);--cosmos-text-font-weight:var(--cosmos-radio-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-line-height);--cosmos-text-text-transform:var(--cosmos-radio-text-transform);display:-ms-flexbox;display:flex;position:relative}.cosmos-radio--hovered .cosmos-radio__label-text{--cosmos-text-color:var(--cosmos-radio-color-hover)}.cosmos-radio--appearance-dark{color:var(--cosmos-radio-color, #000F1E)}.cosmos-radio--appearance-dark .cosmos-radio__input{background:var(--cosmos-radio-background-color, transparent);border-color:var(--cosmos-radio-border-color, rgba(0, 15, 30, 0.6))}.cosmos-radio--appearance-dark .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color, #000F1E)}.cosmos-radio--appearance-dark .cosmos-radio__input:checked~.cosmos-radio__dot{background-color:var(--cosmos-radio-dot-color, #FFFFFF)}.cosmos-radio--appearance-dark .cosmos-radio__input-container:hover,.cosmos-radio--appearance-dark.cosmos-radio--hovered{color:var(--cosmos-radio-color-hover, #000F1E)}.cosmos-radio--appearance-dark .cosmos-radio__input-container:hover .cosmos-radio__input,.cosmos-radio--appearance-dark.cosmos-radio--hovered .cosmos-radio__input{background:var(--cosmos-radio-background-color-hover, rgba(0, 15, 30, 0.1))}.cosmos-radio--appearance-dark .cosmos-radio__input-container:hover .cosmos-radio__input:checked,.cosmos-radio--appearance-dark.cosmos-radio--hovered .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color-hover, rgba(0, 15, 30, 0.8))}.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid) .cosmos-radio__input:checked{border-color:transparent}.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid) .cosmos-radio__input-container:hover .cosmos-radio__input,.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid).cosmos-radio--hovered .cosmos-radio__input{border-color:var(--cosmos-radio-border-color-hover, rgba(0, 15, 30, 0.6))}.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid) .cosmos-radio__input-container:hover .cosmos-radio__input:checked,.cosmos-radio--appearance-dark:not(.cosmos-radio--invalid).cosmos-radio--hovered .cosmos-radio__input:checked{border-color:var(--cosmos-radio-background-color-hover, rgba(0, 15, 30, 0.1))}.cosmos-radio--appearance-light{color:var(--cosmos-radio-color, #FFFFFF)}.cosmos-radio--appearance-light .cosmos-radio__input{background:var(--cosmos-radio-background-color, transparent);border-color:var(--cosmos-radio-border-color, rgba(255, 255, 255, 0.6))}.cosmos-radio--appearance-light .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color, #FFFFFF)}.cosmos-radio--appearance-light .cosmos-radio__input:checked~.cosmos-radio__dot{background-color:var(--cosmos-radio-dot-color, #000F1E)}.cosmos-radio--appearance-light .cosmos-radio__input-container:hover,.cosmos-radio--appearance-light.cosmos-radio--hovered{color:var(--cosmos-radio-color-hover, #FFFFFF)}.cosmos-radio--appearance-light .cosmos-radio__input-container:hover .cosmos-radio__input,.cosmos-radio--appearance-light.cosmos-radio--hovered .cosmos-radio__input{background:var(--cosmos-radio-background-color-hover, rgba(255, 255, 255, 0.1))}.cosmos-radio--appearance-light .cosmos-radio__input-container:hover .cosmos-radio__input:checked,.cosmos-radio--appearance-light.cosmos-radio--hovered .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color-hover, rgba(255, 255, 255, 0.8))}.cosmos-radio--appearance-light:not(.cosmos-radio--invalid) .cosmos-radio__input:checked{border-color:transparent}.cosmos-radio--appearance-light:not(.cosmos-radio--invalid) .cosmos-radio__input-container:hover .cosmos-radio__input,.cosmos-radio--appearance-light:not(.cosmos-radio--invalid).cosmos-radio--hovered .cosmos-radio__input{border-color:var(--cosmos-radio-border-color-hover, rgba(255, 255, 255, 0.6))}.cosmos-radio--appearance-light:not(.cosmos-radio--invalid) .cosmos-radio__input-container:hover .cosmos-radio__input:checked,.cosmos-radio--appearance-light:not(.cosmos-radio--invalid).cosmos-radio--hovered .cosmos-radio__input:checked{border-color:var(--cosmos-radio-background-color-hover, rgba(255, 255, 255, 0.1))}.cosmos-radio--disabled{pointer-events:none}.cosmos-radio--disabled .cosmos-radio__prefix{opacity:0.4}.cosmos-radio--disabled.cosmos-radio--appearance-dark .cosmos-radio__input{border-color:var(--cosmos-radio-border-color, rgba(0, 15, 30, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-dark .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color, rgba(0, 15, 30, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-dark .cosmos-radio__label-text{--cosmos-text-color:var(--cosmos-radio-color, rgba(0, 15, 30, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-light .cosmos-radio__input{border-color:var(--cosmos-radio-border-color, rgba(255, 255, 255, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-light .cosmos-radio__input:checked{background:var(--cosmos-radio-background-color, rgba(255, 255, 255, 0.45))}.cosmos-radio--disabled.cosmos-radio--appearance-light .cosmos-radio__label-text{--cosmos-text-color:var(--cosmos-radio-color, rgba(255, 255, 255, 0.45))}.cosmos-radio--invalid .cosmos-radio__input{border-color:var(--cosmos-radio-invalid-color, #E06600);border-width:var(--cosmos-radio-border-width, 2px)}";
const CosmosRadioStyle0 = cosmosRadioCss;

const generateClassNames = bem('cosmos-radio');
const CosmosRadio$1 = /*@__PURE__*/ proxyCustomElement(class CosmosRadio extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inputchangeEvent = createEvent(this, "inputchange", 6);
        this.inputinvalidEvent = createEvent(this, "inputinvalid", 7);
        this.radios = [];
        this.hoveredOn = () => {
            this.isHovered = true;
        };
        this.hoveredOff = () => {
            this.isHovered = false;
        };
        this.handleFormData = (event) => {
            if (!!this.name && this.input && this.input.checked && !this.disabled) {
                return event.formData.append(this.input.name, this.input.value);
            }
        };
        this.handleFormSubmit = (event) => {
            const isValid = this.reportValidity();
            if (!isValid) {
                event.preventDefault();
            }
        };
        this.handleInvalid = (event) => {
            if (this.group) {
                // Disable the native validation tooltip
                event.preventDefault();
            }
            this.inputInvalid = true;
            this.inputinvalidEvent.emit();
        };
        this.handleChange = () => {
            var _a;
            // Sync of checked property will emit an `inputchange` event
            this.checked = (_a = this.input) === null || _a === void 0 ? void 0 : _a.checked;
        };
        this.handleSlotChange = () => {
            this.labelText = getDefaultSlotTextContent(this.defaultSlotRef);
        };
        this.appearance = undefined;
        this.autofocus = undefined;
        this.checked = false;
        this.clamp = undefined;
        this.disabled = false;
        this.focusable = true;
        this.hitArea = 'content';
        this.invalid = false;
        this.name = undefined;
        this.required = false;
        this.value = undefined;
        this.computedAppearance = 'dark';
        this.inputInvalid = false;
        this.isHovered = false;
        this.labelText = '';
        this.tabIndex = 0;
    }
    /**
     * Returns the validity status of the Radio's value.
     * Fires an `inputinvalid`  event in the case of invalidity.
     */
    async inputCheckValidity() {
        return this.checkValidity();
    }
    /**
     * Performs the same validity checking steps as the `inputCheckValidity` methods.
     * Fires an `inputinvalid` event and reports the problem to the user in case of invalidity.
     */
    async inputReportValidity() {
        return this.reportValidity();
    }
    /**
     * Sets a custom error message for the native validation issue report.
     */
    async inputSetCustomValidity(message) {
        var _a;
        (_a = this.input) === null || _a === void 0 ? void 0 : _a.setCustomValidity(message);
    }
    /**
     * Sets focus on the Radio. This will scroll the element into the view and focus it.
     */
    async inputFocus() {
        var _a;
        (_a = this.input) === null || _a === void 0 ? void 0 : _a.focus();
    }
    /**
     * Removes focus from the Radio.
     */
    async inputBlur() {
        var _a;
        (_a = this.input) === null || _a === void 0 ? void 0 : _a.blur();
    }
    handleAppearanceChange(appearance) {
        this.computedAppearance = appearance;
    }
    handleFocusableChange(newValue) {
        this.setTabindexFromFocusable(newValue);
    }
    handleInvalidChange(newValue) {
        this.inputInvalid = newValue;
    }
    handleCheckedChange(checked, oldChecked) {
        if (checked && checked !== oldChecked) {
            this.inputchangeEvent.emit();
        }
    }
    deriveTextAppearance() {
        return this.computedAppearance === 'light' ? 'light' : 'dark';
    }
    hasLabel() {
        var _a;
        return ((_a = this.element.textContent) === null || _a === void 0 ? void 0 : _a.trim()) !== '';
    }
    hasContent() {
        return this.hasLabel();
    }
    getTitle() {
        var _a;
        return this.clamp ? (_a = this.element.textContent) === null || _a === void 0 ? void 0 : _a.trim() : undefined;
    }
    hasPrefix() {
        return hasNamedSlot(this.element, 'prefix');
    }
    checkValidity() {
        var _a, _b;
        // Check if any of the radios in the group is checked
        const isRadioGroupChecked = (_a = this.radios) === null || _a === void 0 ? void 0 : _a.some((radio) => {
            return radio.shadowRoot.querySelector('input[type="radio"]').checked;
        });
        // Check if any of the radios in the group is required
        const isRadioGroupRequired = (_b = this.radios) === null || _b === void 0 ? void 0 : _b.some((radio) => {
            return radio.required;
        });
        // Determine the validity based on the group rather than the individual radio
        return !isRadioGroupRequired || isRadioGroupChecked;
    }
    reportValidity() {
        const isValid = this.checkValidity();
        if (!isValid && this.input) {
            // To report the validity on an individual radios, we need to set the input to required
            this.input.required = true;
            this.input.reportValidity();
        }
        return isValid;
    }
    getAllRadios() {
        if (!this.group) {
            return [this.element];
        }
        const radios = [
            ...this.group.querySelectorAll(`${transformTagName('cosmos-radio')}[name="${this.name}"]`),
        ];
        return radios.filter((item) => !item.disabled);
    }
    getRadioIndex() {
        return this.radios.findIndex((radio) => radio === this.element);
    }
    setTabindexFromFocusable(isFocusable = this.focusable) {
        this.tabIndex = isFocusable ? 0 : -1;
    }
    componentWillLoad() {
        resolveAppearance({
            instance: this,
            modeToAppearanceMap: { dark: 'light', light: 'dark' },
            callback: this.handleAppearanceChange.bind(this),
        });
        this.radios = this.getAllRadios();
        this.radioIndex = this.getRadioIndex();
        this.setTabindexFromFocusable();
    }
    connectedCallback() {
        this.form = this.element.closest('form');
        this.group = this.element.closest(transformTagName('cosmos-radio-group'));
        if (this.form) {
            this.form.addEventListener('formdata', this.handleFormData, true);
            this.form.addEventListener('submit', this.handleFormSubmit, true);
        }
    }
    componentDidLoad() {
        this.labelText = getDefaultSlotTextContent(this.defaultSlotRef);
    }
    disconnectedCallback() {
        if (this.form) {
            this.form.removeEventListener('formdata', this.handleFormData);
            this.form.removeEventListener('submit', this.handleFormSubmit);
        }
    }
    render() {
        return (h("div", { key: '57adc122ab4d554dcd2077e54c3990d73c10f781', class: generateClassNames({
                'appearance': this.computedAppearance,
                'disabled': this.disabled,
                'hovered': this.isHovered,
                'has-prefix': this.hasPrefix(),
                'invalid': this.invalid || this.inputInvalid,
            }), part: "base" }, h("div", { key: 'bf6d53d97ea4b1e05a584dbe6dfa8366a9a3f450', class: generateClassNames('input-and-prefix') }, this.hasContent() && (h("cosmos-text", { "aria-hidden": "true", class: generateClassNames('aligner'), size: "small", tag: "span" })), h("div", { key: 'e1aad8db45a42d7d2a5274be837d54a3c3c76f59', class: generateClassNames('input-container', {
                'end-margin': this.hasPrefix() || this.hasContent(),
            }) }, h("input", { key: '6e3ff91cf40aef1de888fae03a45f656cbac114c', "aria-label": this.labelText, "aria-posinset": this.radioIndex + 1, "aria-setsize": this.radios.length, autofocus: this.autofocus, checked: this.checked, class: generateClassNames('input'), disabled: this.disabled, id: "radio", name: this.name, onInvalid: this.handleInvalid, ref: (el) => (this.input = el), required: this.required, tabIndex: this.tabIndex, type: "radio", value: this.value, onChange: this.handleChange, part: "radio" }), h("span", { key: '9dcea65fcd38627b367f9eda7dacdd31d208bec9', class: generateClassNames('dot') })), h("label", { key: '54b142f048d9217221dccf5148e1eb58f2c458ad', "aria-hidden": "true", htmlFor: "radio", class: generateClassNames('prefix', {
                'end-margin': this.hasContent(),
            }), onMouseEnter: this.hoveredOn, onMouseLeave: this.hoveredOff, part: "prefix" }, h("slot", { key: '63b50d35c0d740ac7c69e2597d881071833b8ec3', name: "prefix" }))), this.hasContent() && (h("div", { class: generateClassNames('content', {
                row: this.hitArea === 'row',
            }) }, this.hasLabel() && (h("label", { class: generateClassNames('label'), htmlFor: "radio" }, h("cosmos-text", { appearance: this.deriveTextAppearance(), class: generateClassNames('label-text'), clamp: this.clamp, onMouseEnter: this.hoveredOn, onMouseLeave: this.hoveredOff, size: "small", tag: "span", title: this.getTitle(), exportparts: "base: label" }, h("span", null, h("slot", { onSlotchange: this.handleSlotChange, ref: (el) => (this.defaultSlotRef = el) })))))))));
    }
    get element() { return this; }
    static get watchers() { return {
        "appearance": ["handleAppearanceChange"],
        "focusable": ["handleFocusableChange"],
        "invalid": ["handleInvalidChange"],
        "checked": ["handleCheckedChange"]
    }; }
    static get style() { return CosmosRadioStyle0; }
}, [1, "cosmos-radio", {
        "appearance": [513],
        "autofocus": [516],
        "checked": [1540],
        "clamp": [516],
        "disabled": [516],
        "focusable": [516],
        "hitArea": [513, "hit-area"],
        "invalid": [516],
        "name": [513],
        "required": [516],
        "value": [513],
        "computedAppearance": [32],
        "inputInvalid": [32],
        "isHovered": [32],
        "labelText": [32],
        "tabIndex": [32],
        "inputCheckValidity": [64],
        "inputReportValidity": [64],
        "inputSetCustomValidity": [64],
        "inputFocus": [64],
        "inputBlur": [64]
    }, undefined, {
        "appearance": ["handleAppearanceChange"],
        "focusable": ["handleFocusableChange"],
        "invalid": ["handleInvalidChange"],
        "checked": ["handleCheckedChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-radio", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-radio":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosRadio$1);
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosRadio = CosmosRadio$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosRadio, defineCustomElement };
